<template>
    <div class="printOrderDetails">
        <!-- 报价流程 -->
        <div class="details">
            <div class="detailsProcess">
                <i
                    class="el-icon-arrow-left"
                    @click="jumpGo"
                ></i>
                <div class="processItem" v-for="(item,index) in processList" :key="index">
                    <!-- <div :class="processActive === item.id?'process_type process_type2':'process_type'" @click="processActive = item.id">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div> -->
                     <div :class="processActive === item.id?'process_type process_type2':'process_type'">
                        <i>{{index + 1}}</i>
                        <p>{{item.name}}</p>
                    </div>
                    <i class="el-icon-arrow-right typeIcon" v-show="item.id !== '5'"></i>
                </div>
            </div>
            <!-- 订单信息 -->
            <div class="orderMessage">
                <div class="orderMessage_title">
                    <h4>订单信息</h4>
                    <p>设计师：{{modelDetail.modelCreatorName}}</p>
                    <i class="iconfont icon-weixin " @click="startChat(modelDetail.modelCreatorUuid)"></i>
                </div>
                <div class="orderMessage_con">
                    <p>订单编号：{{modelDetail.orderBase? modelDetail.orderBase.orderNo:''}}</p>
                    <p>创建时间：{{modelDetail.orderBase?modelDetail.orderBase.createDate:''}}</p>
                    <p v-if="modelDetail.modelStatus === 'UN_RECEIVE' || modelDetail.modelStatus === 'UN_SEND'">付款时间：2021-11-12 11:11:11</p>
                </div>
            </div>
            <!-- 模型信息 -->
            <div class="orderMessage" style="border: none">
                <div class="orderMessage_title">
                    <h4>模型信息</h4>
                </div>
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column prop="num" label="序号" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="modelName" label="模型名称" align="center">
                        <template slot-scope="scope">
                            <div class="designerImg">
                                <img :src="scope.row.modelImg" alt=""/>
                                <p>{{ scope.row.modelName }}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="modelFile.name" label="模型文件名称" align="center">
                        <template slot-scope="scope">
                            <div  class="threeModel" v-for="(items,index) in scope.row.modelFile" :key="index">
                                <p @click="handPreview(items)">{{items.name}}</p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="modelRemark"
                        label="模型描述"
                        width="400"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div class="modelRemarks">{{scope.row.modelRemark}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="实付款" align="center">
                        <template slot-scope="scope">
                           ￥{{scope.row.totalPrice}}
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-table :data="modelFile" style="width: 100%">
                    <el-table-column prop="name" label="模型文件名称" align="center">
                    </el-table-column>

                    <el-table-column
                        prop="url"
                        label="模型文件地址"
                        width="400"
                        align="center"
                    >
                    </el-table-column>
                </el-table> -->
            </div>
            <div class="orderRecordButton">
                <el-button plain v-if="modelDetail.modelStatus === 'UN_PAY'" @click="submitPay(modelDetail)">付款</el-button>
                <el-button plain v-if="modelDetail.modelStatus === 'UN_PAY'" @click="cancelOrder(modelDetail)">取消订单</el-button>
                <el-button plain v-if="modelDetail.modelStatus=='UN_APPRAISE'" @click="toEvaluate(modelDetail)">评价</el-button>
                <el-button type="primary" :loading="modelDownLoading" v-if="modelDetail.modelStatus !== 'CANCEL' && modelDetail.modelStatus !== 'UN_PAY'" @click="handleBatchDownload(modelDetail.uuid)">下载</el-button>
                <el-button type="primary" v-if="modelDetail.modelStatus !== 'CANCEL' && modelDetail.modelStatus !== 'UN_PAY'" @click="handleToPrint(modelDetail)">去打印</el-button>
            </div>
        </div>
        <!-- 购买的弹窗 -->
        <PayModelDialog ref="payModelRef" @refreshData="getDetail"/>

        <!-- 取消订单 -->
        <el-dialog
            title="取消订单"
            :visible.sync="cancelDialogVisible"
            :close-on-click-modal="false"
            width="1000px">
            <div class="logisticsDialog">
                <el-form ref="logisticsForm" :rules="cancelRules" class="demo-ruleForm">
                    <el-form-item class="addressList">
                        <el-select v-model="cancelUuid" placeholder="取消原因">
                            <el-option v-for="(item,index) in cancelList" :key="index"
                                       :label="item.name"
                                       :value="item.uuid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="submitButtonGroup">
                        <el-button type="primary" @click="cancelSubmit">确定</el-button>
                        <el-button @click="cancelDialogVisible = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <!--评价弹出框-->
        <el-dialog
            title="评价"
            :visible.sync="evaluateDialogVisible"
            width="500px">
            <div class="evaluateDialogBox">
                <div class="evaluateItem">
                    <div class="name">评价等级</div>
                    <div class="content">
                        <div class="rateItem">
                            <div class="name">描述相符</div>
                            <el-rate
                                v-model="evaluateForm.descriptionPoint"
                                show-score
                                text-color="#ff9900">
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">服务态度</div>
                            <el-rate
                                v-model="evaluateForm.servicePoint"
                                show-score
                                text-color="#ff9900">
                            </el-rate>
                        </div>
                        <div class="rateItem">
                            <div class="name">专业程度</div>
                            <el-rate
                                v-model="evaluateForm.transportPoint"
                                show-score
                                text-color="#ff9900">
                            </el-rate>
                        </div>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价标签</div>
                    <div class="content">
                        <el-checkbox-group v-model="evaluateForm.evaluationTagList" class="evaluateTag">
                            <el-checkbox-button v-for="tag in tagList" :label="tag" :key="tag.uuid">{{tag.tagName}}
                            </el-checkbox-button>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="evaluateItem">
                    <div class="name">评价内容</div>
                    <div class="content">
                        <el-input
                            type="textarea"
                            :autosize="{ minRows: 6}"
                            placeholder="请输入内容"
                            v-model="evaluateForm.evaluationContent">
                        </el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="evaluateDialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 3d预览 -->
        <three-d
        ref="threeBox"
        :innerVisible="innerVisible"
        :fileListNew="fileListNew"
        @closeDlog="closeDlog"
        ></three-d>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>
    </div>
</template>

<script>
import {
    getModelOrderDetail, getModelDetail, getDictionaryItem, saveEvaluation, getRongCloudUser, editOrder,downloadFile
} from "../../../utils/interface";
    import {downLoad} from "../../../utils/downLoadModel";
    import threeD from "../../../components/threeD/index"
    import chatDialog from "../../../components/chat/chatDialog";
    import PayModelDialog from './payModelDialog';
    export default {
        name: "printOrderDetails",
        data() {
            return {
                stepLoading: false,
                tableData: [],
                modelFile: [],
                evaluateDialogVisible: false,
                evaluateForm: {
                    descriptionPoint: 0,
                    servicePoint: 0,
                    transportPoint: 0,
                    evaluationTagList: [],
                    evaluationContent: ''
                },
                tagList: [
                    {
                        uuid: '0',
                        name: '服务好'
                    },
                    {
                        uuid: '1',
                        name: '态度好'
                    },
                    {
                        uuid: '2',
                        name: '质量好'
                    },
                    {
                        uuid: '3',
                        name: '效率高'
                    },
                    {
                        uuid: '4',
                        name: '标签标签标签标签标签标签'
                    },
                    {
                        uuid: '5',
                        name: '标签标签'
                    }
                ],
                processActive: '0',
                processList: [
                    {
                        id: '0',
                        name: '买家下单'
                    },
                    {
                        id: '1',
                        name: '订单支付'
                    },
                    {
                        id: '2',
                        name: '评价'
                    },
                    {
                        id: '3',
                        name: '完成'
                    }
                ],
                modelDetail: {},
                fileListNew: [],
                innerVisible: false,
                modelDownLoading: false,
                // 取消订单
                cancelDialogVisible:false,
                cancelList:[],
                cancelUuid:"",
                cancelRules: {
                    cancelUuid:[
                        {required: true, message: '请选择取消原因', trigger: 'change'}
                    ]
                },
                modelOrderUuid:"",
                orderBaseUuid:"",
            };
        },
        components: {
            threeD,
            chatDialog,
            PayModelDialog
        },
        mounted(){
            this.getDetail()
            this.getDictionaryItem();
        },
        methods: {
            // 取消
            cancelOrder(item){
                getDictionaryItem({groupCode:"model_cancel_reason"}).then((res)=>{
                    this.cancelList = res;
                    this.modelOrderUuid = item.uuid;
                    this.orderBaseUuid = item.orderBase.uuid;
                    this.cancelDialogVisible = true;
                });
            },
            cancelSubmit(){
                if(this.cancelUuid==""){
                    this.$message.error('请选择取消原因！');
                    return false;
                }
                editOrder({uuid:this.modelOrderUuid, modelStatus:"CANCEL",cancelOrderUuid:this.cancelUuid}).then((res)=>{
                    if(res.success){
                        this.$message.success('订单取消成功！');
                        this.cancelUuid = "";
                        this.cancelDialogVisible = false;
                        this.getDetail();
                    }
                });
            },
            // 支付
            submitPay(item){
                this.$refs.payModelRef.init()
                window.open(this.$url.payUrl + item.orderBase.orderNo, "_blank");
            },
            // 获取字典值
            getDictionaryItem() {
                getDictionaryItem({groupCode: "model_evaluation_tag"}).then((res) => {
                    this.tagList = [];
                    res.forEach((item, index) => {
                        this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
                    });
                });
            },
            // 获取模型订单详情
            getDetail(){
                getModelOrderDetail({uuid:this.$route.query.uuid}).then(res=>{
                    this.modelDetail = res
                    if(res.modelStatus == 'UN_PAY'){
                        this.processActive ='1';
                    }else if(res.modelStatus == 'UN_APPRAISE'){
                        this.processActive ='2';
                    }else if(res.modelStatus == 'FINISHED'){
                        this.processActive ='3';
                    }
                    this.tableData = []
                    this.tableData.push({
                        num: "01",
                        modelName: res.modelName,
                        modelImg: res.modelImg,
                        totalPrice: res.orderBase.totalPrice,
                        modelRemark: res.modelRemark,
                        modelFile: res.modelFile,
                    })
                    // this.modelFile = res.modelFile;
                    // console.log('this.tableData', this.tableData,res.modelFile);
                })
            },
            // 点击打开评价弹出框
            toEvaluate(order) {
                this.order = order;
                this.evaluateForm = {
                    descriptionPoint: 0,
                    servicePoint: 0,
                    transportPoint: 0,
                    evaluationTagList: [],
                    evaluationContent: ''
                }
                this.evaluateDialogVisible = true
            },
            // 评价提交
            evaluateSubmit() {
                this.stepLoading = true;
                if (
                    this.evaluateForm.descriptionPoint &&
                    this.evaluateForm.servicePoint &&
                    this.evaluateForm.transportPoint
                ) {
                    this.evaluateForm.orderNo = this.order.orderBase.orderNo;
                    this.evaluateForm.orderUuid = this.order.uuid;
                    this.evaluateForm.orderType = 'MODEL';
                    this.evaluateForm.evaluationType = 'NORMAL';
                    this.evaluateForm.sellerName = this.order.modelCreatorName;
                    this.evaluateForm.sellerUuid = this.order.modelCreatorUuid;
                    this.evaluateForm.orderName = this.modelName;
                    this.evaluateForm.orderAmount = this.order.orderBase.totalPrice;

                    saveEvaluation(this.evaluateForm).then((response) => {
                        if (response.success) {
                            this.evaluateDialogVisible = false;
                            this.getDetail();
                            this.$message({
                                type: "success",
                                message: "评价成功",
                            });
                        } else {
                            this.$message({
                                type: "error",
                                message: response.message,
                            });
                        }
                    });
                } else {
                    this.$message.warning("请选择评价等级");
                }
                setTimeout(() => {
                    this.stepLoading = false;
                }, 1000);
            },
            // 点击去打印
            handleToPrint(item){
                window.open(this.$url.threeWeb+"/printPlaceAnOrder?modelUuid="+item.modelUuid,'_target');
            },
            // 模型下载
            handleBatchDownload(val) {
                this.modelDownLoading = true
                downloadFile(val).then((res) => {
                    if(res.headers["error"]){
                        this.$message.error(decodeURI(res.headers["error"]))
                    }else if(res && res.data){
                        let zip = window.URL.createObjectURL(new Blob([res.data],{type: "application/zip"}));
                        let fileName = res.headers["content-disposition"].split(";")[1].split("filename=")[1];
                        let s= /\"/g
                        fileName = fileName.replace(s,'')
                        fileName = decodeURI(fileName)  //对文件名decodeURI解码，解决中文名乱码问题
                        const link = document.createElement('a');
                        link.href = zip;
                        link.setAttribute('download', fileName);
                        document.body.appendChild(link);
                        link.click()
                        const a = URL.revokeObjectURL(link.href); // 释放
                        this.$message.success("文件打包成功")
                        this.modelDownLoading = false
                    }
                });
                /*getModelDetail({uuid: val}).then( async (res) => {
                    let data = [];
                    res.urlList.map((file) => {
                        if (file.fileType === "FILE") {
                            let obj = {};
                            obj.name = file.name;
                            obj.url = file.modelUrl;
                            data.push(obj);
                        }
                    });
                    this.modelDownLoading = true
                    try {
                        let modelMess = await downLoad(data, res.modelName + ".zip")
                        if (modelMess == true) {
                            this.$message.success("文件打包成功")
                        } else {
                            this.$message.error("文件打包失败")
                        }
                    } catch (error) {
                        this.$message.error("文件打包错误,请联系管理员！")
                    }
                    this.modelDownLoading = false
                    // downLoad(data, "打包下载.zip");
                });*/
            },
            // 预览模型
            handPreview(info) {
                this.$refs.threeBox.threeAnimal(info);
                this.innerVisible = !this.innerVisible;
            },
            closeDlog(index) {
                this.innerVisible = index;
            },
            startChat(targetUuid) {
                let user = this.$store.state.userMessages;
                getRongCloudUser(targetUuid).then(res=> {
                    console.log(res);
                    this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
                });
            },
            jumpGo(){
                this.$router.push('/modelOrderList')
            },
        },
    };
</script>

<style scoped lang="less">
    p {
        margin: 0;
    }

    i {
        font-style: normal;
    }

    .printOrderDetails {
        background: #f5f5f5;
        // 订单状态
        .detailsState {
            background: #fff;
            font-size: 14px;
            padding: 26px 32px;
            margin-bottom: 8px;

            .detailsState_one {
                display: flex;
                align-items: center;

                &:nth-of-type(1) {
                    margin-bottom: 16px;
                }

                i {
                    font-size: 18px;
                    margin-right: 5px;
                    cursor: pointer;
                }

                .detailsState_one_title {
                    font-size: 16px;
                    font-weight: 500;
                    margin-right: 8px;
                }

                .detailsState_one_time {
                    color: #1890ff;
                }
            }
        }

        // 报价流程
        .details {
            background: #fff;
            padding: 0 8px;

            .detailsProcess {
                border-bottom: 1px solid #efefef;
                display: flex;
                align-items: center;
                .processItem{
                    display: flex;
                    align-items: center;
                    // cursor: pointer;
                    // &:hover{
                    //     .process_type{
                    //         i {
                    //             background: #1890ff;
                    //             color: #fff;
                    //             border: 1px solid #1890ff;
                    //         }
                    //         p {
                    //             color: #000;
                    //         }
                    //     }
                    // }
                }
                .process_type {
                    width: 232px;
                    height: 64px;
                    // line-height: 64px;
                    display: flex;
                    align-items: center;
                    // border-bottom: 2px solid #1890ff;
                    text-align: center;
                    justify-content: center;
                    i {
                        display: inline-block;
                        width: 24px;
                        height: 24px;
                        border: 1px solid rgba(0, 0, 0, 0.15);
                        border-radius: 50%;
                        color: rgba(0, 0, 0, 0.15);
                        line-height: 27px;
                        font-size: 14px;
                        margin-right: 8px;
                    }
                    p {
                        font-size: 16px;
                        color: rgba(0, 0, 0, 0.3);
                    }
                }
                .typeIcon {
                    color: rgba(0, 0, 0, 0.3);
                    font-size: 18px;
                }
                .process_type2 {
                    border-bottom: 3px solid #1890ff;
                    i {
                        background: #1890ff;
                        color: #fff;
                        border: 1px solid #1890ff;
                    }
                    p {
                        color: #000;
                    }
                }
            }

            // 订单信息
            .orderMessage {
                border-bottom: 1px solid #efefef;
                margin: 0 24px;
                padding-bottom: 8px;

                .orderMessage_title {
                    height: 64px;
                    display: flex;
                    align-items: center;

                    h4 {
                        font-size: 16px;
                        font-weight: 500;
                        color: rgba(0, 0, 0, 0.85);
                        margin-right: 24px;
                    }

                    p {
                        font-size: 14px;
                        color: rgba(0, 0, 0, 0.85);
                        margin-right: 15px;
                    }

                    i {
                        color: #1890ff;
                        cursor: pointer;
                    }
                }

                .orderMessage_con {
                    display: flex;
                    align-items: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                    margin-bottom: 16px;

                    p {
                        width: 362px;
                    }
                }

                .designerImg {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 64px;
                        height: 64px;
                        margin-right: 8px;
                    }

                    i {
                        color: #1890ff;
                    }
                }
                .threeModel {
                    p {
                        margin-bottom: 5px;
                        cursor: pointer;
                        color: #1890ff;
                    }
                }
                .modelRemarks {
                    display: -webkit-box;
                    overflow: hidden;
                    white-space: normal !important;
                    text-overflow: ellipsis;
                    word-wrap: break-word;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical
                }
            }

            .orderRecordButton {
                margin-top: 24px;
                text-align: right;
                margin-bottom: 70px;
                margin-right: 20px;
            }
        }
    }

    .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #DCDFE6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/modelOrderDetail.vue